import purchasingPower from './purchasingPower.reducer'

export default purchasingPower
